import { render, staticRenderFns } from "./oneroster0.vue?vue&type=template&id=ed2fc9a4&scoped=true&"
import script from "./oneroster0.ts?vue&type=script&lang=ts&"
export * from "./oneroster0.ts?vue&type=script&lang=ts&"
import style0 from "./oneroster0.scss?vue&type=style&index=0&id=ed2fc9a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2fc9a4",
  null
  
)

export default component.exports